const { LAYER_ROLES } = require('../layerTypes');
const { VARIATION_TEXT_FIELDS } = require('./constants');

/**
 * @param {VariationContent} VariationContent
 * @returns {VariationTextFields} - Variation text fields
 */
const getVariationTextFields = ({ roots }) => roots
    .filter(({ layerRole }) => VARIATION_TEXT_FIELDS.includes(layerRole))
    .reduce((acc, { layers, layerRole }) => {
        const [textLayer] = layers;

        return {
            ...acc,
            [layerRole]: textLayer.children || ''
        };
    }, {
        [LAYER_ROLES.SLOGAN]: '',
        [LAYER_ROLES.BRAND_NAME]: ''
    });

module.exports = getVariationTextFields;
